import GenericStatusContainer from './generic_status_container';

const GenericStatus = GenericStatusContainer;

export default GenericStatus;
